import { Container } from './styles'

export default function ContainerCentralCliente({ children }) {
    return(
        <Container>
            {children}
        </Container>
    )
}